export { default as main } from './assets/logos/cubejs.svg';
export { default as cubeCloud } from './assets/logos/cubecloud.svg';
